import { ChevronLeft, ShieldCheck, ShieldOff } from 'lucide-react';
import { BACK_BTN } from './helper';

// Asked before anything is on file. "Add insurance / Mark as self-pay" made the
// patient translate their own situation into our filing categories; this asks
// the question they can actually answer and routes from there.
const OPTION =
  'flex flex-1 cursor-pointer flex-col items-center gap-1.5 rounded-xl border border-gray-200 bg-white p-5 text-center transition-colors hover:border-teamcare-blue hover:bg-blue-50/50 disabled:cursor-default disabled:opacity-60 disabled:hover:border-gray-200 disabled:hover:bg-white';

const CHOICES = [
  {
    key: 'yes',
    icon: ShieldCheck,
    label: 'Yes, I have insurance',
    hint: "Add your plan and we'll check your benefits before your visit",
  },
  {
    key: 'no',
    icon: ShieldOff,
    label: "No, I don't",
    hint: 'See what the practice offers instead',
  },
];

const Question = ({ onAnswer, onCancel = null, disabled = false }) => (
  <div
    className={`relative flex flex-col items-center rounded-2xl border border-gray-200 bg-white px-6 pb-10 text-center ${onCancel ? 'pt-14' : 'pt-10'}`}
  >
    {onCancel && (
      <button
        type="button"
        onClick={onCancel}
        disabled={disabled}
        aria-label="Back"
        className={`${BACK_BTN} absolute left-4 top-4`}
      >
        <ChevronLeft size={16} strokeWidth={2.5} />
      </button>
    )}

    <p className="text-base font-bold text-secondary-900">Do you have dental insurance?</p>
    <p className="mt-1 max-w-sm text-sm text-secondary-500">
      Either answer is fine — it just tells us how to bill you.
    </p>

    <div className="mt-5 flex w-full max-w-lg flex-col gap-3 sm:flex-row">
      {CHOICES.map(({ key, icon: Icon, label, hint }) => (
        <button key={key} type="button" onClick={() => onAnswer(key)} disabled={disabled} className={OPTION}>
          <Icon size={22} strokeWidth={2} className="text-teamcare-blue" />
          <span className="text-sm font-bold text-secondary-900">{label}</span>
          <span className="text-xs leading-relaxed text-secondary-500">{hint}</span>
        </button>
      ))}
    </div>
  </div>
);

export default Question;
